<div class="offcanvas sidebar" id="sidebar">
    <a class="dashboard-nav-item" routerLinkActive="active" routerLink="" [routerLinkActiveOptions]="{exact: true}">
        <div class="fa fa-home fontNew">

        </div>
        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-house"
            viewBox="0 0 25 25">
            <path
                d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5z" />
        </svg> -->
        <span class="margin">Home </span></a>
    <nav class="dashboard-nav-list">
        <ul>
            <li class='dashboard-nav-dropdown' *ngFor="let menu of menuListFinal" aria-hidden="true">
                <a *ngIf="menu?.userMenusImpls==null" class="dashboard-nav-item nav-link"
                    [ngClass]="{'dropdown dashboard-nav-dropdown-toggle': menu?.userMenusImpls?.length>0}"
                    data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"
                    [routerLinkActiveOptions]="{exact: false}" routerLinkActive="active"
                    [routerLink]="currentMenu+'/'+menu.menuCode">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor"
                    class="bi bi-record-circle" viewBox="0 0 25 25">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                    <path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                </svg>
                    {{menu.menuName}} </a>
                <a *ngIf="menu?.userMenusImpls?.length> 0" class="dashboard-nav-item nav-link"
                    [ngClass]="{'dropdown dashboard-nav-dropdown-toggle': menu?.userMenusImpls?.length>0}"
                    data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor"
                    class="bi bi-record-circle" viewBox="0 0 25 25">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                    <path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                </svg> {{menu.menuName}}
                </a>
                <ng-container *ngIf="menu?.userMenusImpls?.length> 0">
                    <div class='dashboard-nav-dropdown-menu dropdown-menu dropdown' (click)="stopRedirection($event)">
                        <li *ngFor="let sublist of menu.userMenusImpls; let i = index" class="dashboard-nav-dropdown-item"
                            [ngClass]="{' dropdown d-block': sublist?.childmenu?.length>0}" data-toggle="dropdown" role="button"
                            aria-haspopup="true" aria-expanded="false" routerLinkActive="active">
                            <a *ngIf="sublist?.userMenusImpls==null"
                                [ngClass]="{'dropdown dashboard-nav-dropdown-toggle': sublist?.userMenusImpls?.length> 0}"
                                [routerLink]="currentMenu+'/'+menu.menuCode+'/'+sublist.menuCode" (click)="hiddenMenus[i]=!hiddenMenus[i]"
                                [routerLinkActiveOptions]="{exact: false}" class="dashboard-nav-child">
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor"
                                class="bi bi-arrow-return-right" viewBox="0 0 25 25">
                                <path fill-rule="evenodd"
                                    d="M1.5 1.5A.5.5 0 0 0 1 2v4.8a2.5 2.5 0 0 0 2.5 2.5h9.793l-3.347 3.346a.5.5 0 0 0 .708.708l4.2-4.2a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 8.3H3.5A1.5 1.5 0 0 1 2 6.8V2a.5.5 0 0 0-.5-.5" />
                            </svg>{{sublist.menuName}} </a>
                            <a *ngIf="sublist?.userMenusImpls?.length> 0"
                                [ngClass]="{'dropdown dashboard-nav-dropdown-toggle': sublist?.userMenusImpls?.length> 0}"
                                (click)="hiddenMenus[i]=!hiddenMenus[i]" class="dashboard-nav-child">{{sublist.menuName}} </a>
                            <ng-container *ngIf="sublist?.userMenusImpls?.length> 0">
                                <ul *ngIf="hiddenMenus[i]">
                                    <li class="dashboard-nav-dropdown-item" routerLinkActive="active"
                                        *ngFor="let submenu of sublist.userMenusImpls">
                                        <a [routerLink]="currentMenu+'/'+menu.menuCode+'/'+sublist.menuCode+'/'+submenu.menuCode"
                                            [routerLinkActiveOptions]="{exact: true}"
                                            class="dashboard-nav-child">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor"
                                class="bi bi-arrow-return-right" viewBox="0 0 25 25">
                                <path fill-rule="evenodd"
                                    d="M1.5 1.5A.5.5 0 0 0 1 2v4.8a2.5 2.5 0 0 0 2.5 2.5h9.793l-3.347 3.346a.5.5 0 0 0 .708.708l4.2-4.2a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 8.3H3.5A1.5 1.5 0 0 1 2 6.8V2a.5.5 0 0 0-.5-.5" />
                            </svg>{{submenu.menuName}} </a>
                                    </li>
                                </ul>
                            </ng-container>
                        </li>
                    </div>
                </ng-container>
            </li>
        </ul>
    </nav>
</div>